<div class="details-name-value-pair">
  <label class="details-name">{{name}}</label>
  <div (click)='getArrangementUrl()' *ngIf='clickable ; else has_link'>
    <div class="details-value clickable">{{value ? value : emptyValuePlaceholder}}</div>
  </div>
  <ng-template #has_link>
    <div (click)='redirectToLink()' *ngIf='hasLink ; else has_link_to_same_tab'>
      <div class="details-value clickable">{{value ? value : emptyValuePlaceholder}}</div>
    </div>
  </ng-template>
  <ng-template #has_link_to_same_tab>
    <div (click)='redirectToLinkSameTab()' *ngIf='hasLinkToSameTab ; else has_popup'>
      <div class="details-value clickable">{{value ? value : emptyValuePlaceholder}}</div>
    </div>
  </ng-template>
  <ng-template #has_popup>
    <div (click)="openPopup()" *ngIf="hasPopup ; else not_clickable">
      <div class="details-value clickable">{{value ? value : emptyValuePlaceholder}}</div>
    </div>
  </ng-template>
  <ng-template #not_clickable>
    <div [ngSwitch]='type'>
      <div class="details-value" [ngClass]="{'red': value < 0}" *ngSwitchCase="'amount'">
        {{(value || value === 0) ? (value | currency:'EUR':'symbol') : emptyValuePlaceholder}}
      </div>
      <div class="details-value" [ngClass]="{'red': value < 0}" *ngSwitchCase="'foreignAmount'">
        {{(value || value === 0) ? (value | currency:currencyCode:'symbol') : emptyValuePlaceholder}}
      </div>
      <div class="details-value" *ngSwitchCase="'percentage'">
        {{(value || value === 0) ? (value.toFixed(2).replace('.', ',') + '%') : emptyValuePlaceholder}}
      </div>
      <div class="details-value" *ngSwitchDefault>
        {{value? value : emptyValuePlaceholder}}
      </div>
    </div>
  </ng-template>
</div>
